<template>
  <div class="bg-primary">
    <a-row>
      <a-col :span="24" :xxl="{span:8, offset:8}" :xl="{span:8, offset:8}" :lg="{span:12, offset:6}"
             :md="{span:16, offset:4}">
        <a-card title="学会网站平台——个人会员注册"
                :bordered="false"
                style="width: 100%; margin:4rem 0"
                :headStyle="{textAlign:'center', fontWeight:'bolder',fontSize:'1.5rem'}">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <a-form-model-item ref="name" label="姓名" prop="name">
              <a-input
                v-model="form.name"
                @change="error.name=''"
                @blur="
          () => {
            $refs.name.onFieldBlur();
          }"/>
              <span class="text-danger" v-if="error.name">{{ error.name }}</span>
            </a-form-model-item>
            <a-form-model-item label="出生年月" required prop="birthday">
              <a-date-picker
                v-model="form.birthday"
                @change="error.birthday=''"
                type="date"
                placeholder="选择一个日期"
                valueFormat="YYYY-MM-DD"
                style="width: 100%;"
              />
              <span class="text-danger" v-if="error.birthday">{{ error.birthday }}</span>
            </a-form-model-item>
            <a-form-model-item label="性别" prop="gender">
              <a-radio-group v-model="form.gender">
                <a-radio value="male">
                  男
                </a-radio>
                <a-radio value="female">
                  女
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="民族" required prop="nation">

              <a-select
                show-search
                placeholder="选择民族"
                option-filter-prop="children"
                :filter-option="filterNationOption"
                @focus="handleNationFocus"
                @blur="handleNationBlur"
                @change="handleNationChange"
                v-model="form.nation"
              >
                <template v-for="item in nationMap">
                  <a-select-option :value="item.value" :key="'nation'+ item.value">
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-select>


            </a-form-model-item>
            <a-form-model-item ref="idNum" label="身份证号" prop="idNum">
              <a-input
                v-model="form.idNum"
                @change="error.idNum=''"
                @blur="
          () => {
            $refs.idNum.onFieldBlur();
          }"/>
              <span class="text-danger" v-if="error.idNum">{{ error.idNum }}</span>
            </a-form-model-item>

            <a-form-model-item label="政治面貌" required prop="politics">

              <a-select
                show-search
                placeholder="选择政治面貌"
                option-filter-prop="children"
                :filter-option="filterPoliticsOption"
                @focus="handlePoliticsFocus"
                @blur="handlePoliticsBlur"
                @change="handlePoliticsChange"
                v-model="form.politics"
              >
                <template v-for="item in politicsMap">
                  <a-select-option :value="item.value" :key="'politics'+ item.value">
                    {{ item.name }}
                  </a-select-option>
                </template>

              </a-select>


            </a-form-model-item>

<!--            <a-form-model-item label="专兼职" prop="gender">-->
<!--              <a-radio-group v-model="form.fullPart">-->
<!--                <a-radio value="full">-->
<!--                  专职-->
<!--                </a-radio>-->
<!--                <a-radio value="part">-->
<!--                  兼职-->
<!--                </a-radio>-->
<!--              </a-radio-group>-->
<!--            </a-form-model-item>-->
            <a-form-model-item label="专业">
              <a-input v-model="form.major"></a-input>
            </a-form-model-item>

            <a-form-model-item ref="organization" label="工作单位" prop="organization">
              <a-input
                v-model="form.organization"
                @change="error.organization=''"
                @blur="
          () => {
            $refs.organization.onFieldBlur();
          }
        "
              />
              <span class="text-danger" v-if="error.organization">{{ error.organization }}</span>
            </a-form-model-item>
            <a-form-model-item ref="position" label="单位职务" prop="position">
              <a-input
                v-model="form.position"
                @change="error.position=''"
                @blur="
          () => {
            $refs.position.onFieldBlur();
          }"/>
              <span class="text-danger" v-if="error.position">{{ error.position }}</span>
            </a-form-model-item>
            <a-form-model-item label="职称">
              <a-input v-model="form.title"></a-input>
            </a-form-model-item>
            <a-form-model-item label="地址">
              <a-input v-model="form.address"></a-input>
            </a-form-model-item>
            <a-form-model-item label="邮编">
              <a-input v-model="form.postcode"></a-input>
            </a-form-model-item>

            <a-form-model-item ref="recname" label="推荐人姓名" prop="recname">
              <a-input
                placeholder="推荐人姓名"
                v-model="form.recname"/>
            </a-form-model-item>

            <a-form-model-item ref="recphone" label="推荐人手机号" prop="recphone">
              <a-input
                placeholder="推荐人手机号"
                v-model="form.recphone"/>
            </a-form-model-item>

            <a-form-model-item ref="phone" label="手机号" prop="phone">
              <a-input
                @change="error.phone=''"
                v-model="form.phone"
                @blur="
          () => {
            $refs.phone.onFieldBlur();
          }"/>

              <span class="text-danger" v-if="error.phone">{{ error.phone }}</span>
            </a-form-model-item>

            <a-form-model-item label="座机">

              <a-input-group compact>
                <a-input style="width: 30%" v-model="form.areacode"/>
                <a-input style="width: 70%" v-model="form.telephone"/>
              </a-input-group>

            </a-form-model-item>
            <a-form-model-item ref="email" label="邮箱">

              <a-input v-model="form.email"/>
              <!--              <a-input-search-->
              <!--                placeholder="请输入邮箱号"-->
              <!--                @click="getEmailCode('4')"-->
              <!--                @blur="-->
              <!--          () => {-->
              <!--            $refs.email.onFieldBlur();-->
              <!--          }" >-->
              <!--                <a-button slot="enterButton" type="primary">-->
              <!--                  发送验证码-->
              <!--                </a-button>-->
              <!--              </a-input-search>-->

            </a-form-model-item>

            <a-form-model-item ref="password" label="密码" required prop="password" autocomplete="off">
              <a-input-password v-model="form.password" placeholder="请输入密码"/>
              <span class="text-danger" v-if="error.password">{{ error.password }}</span>
            </a-form-model-item>
            <a-form-model-item ref="password2" label="重复密码" required prop="password2" autocomplete="off">
              <a-input-password v-model="form.password2" placeholder="请再次输入密码"/>
              <span class="text-danger" v-if="error.password2">{{ error.password2 }}</span>
            </a-form-model-item>

            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" style="text-align: center">
              <a-button type="primary" @click="onSubmit">
                注册
              </a-button>
              <a-button style="margin-left: 10px;" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>

            <div style="margin: 24px">
              <router-link :to="{name:'login'}" class="text-primary">已有账号，马上登录</router-link>
              <router-link :to="{name:'registercompany'}" class="text-primary float-right">团队会员注册</router-link>
            </div>
          </a-form-model>
        </a-card>
      </a-col>
    </a-row>


  </div>

</template>
<script>
import {createUserPerson} from "../../api/api";
import cookie from "../../../static/js/cookie";
import {toUnderLineObj} from "../../../static/js/util";
import message from 'ant-design-vue/lib/message';
import 'ant-design-vue/lib/message/style/css';

export default {
  name: "Register",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
        if (this.form.password !== '') {
          callback();
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {

      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入的密码不相同!"));
      } else {
        callback();
      }
    };

    return {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
      other: '',

      form: {
        name: '',
        organization: '',
        position: '',
        title: '',
        major: '',
        address: '',
        postcode: '',
        phone: '',
        areacode: '',
        telephone: '',
        email: '',
        password: '',
        birthday: undefined,
        gender: 'male',
        recname: '',
        recphone: '',
        part: 'P',
        password2: '',
        nation: '1',
        fullPart: 'part',
        idNum: '',
        politics: ''

      },
      nationMap: [
        {value: "1", name: "汉族"},
        {value: "2", name: "蒙古族"},
        {value: "3", name: "回族"},
        {value: "4", name: "藏族"},
        {value: "5", name: "维吾尔族"},
        {value: "6", name: "苗族"},
        {value: "7", name: "彝族"},
        {value: "8", name: "壮族"},
        {value: "9", name: "布依族"},
        {value: "10", name: "朝鲜族"},
        {value: "11", name: "满族"},
        {value: "12", name: "侗族"},
        {value: "13", name: "瑶族"},
        {value: "14", name: "白族"},
        {value: "15", name: "土家族"},
        {value: "16", name: "哈尼族"},
        {value: "17", name: "哈萨克族"},
        {value: "18", name: "傣族"},
        {value: "19", name: "黎族"},
        {value: "20", name: "傈傈族"},
        {value: "21", name: "佤族"},
        {value: "22", name: "畲族"},
        {value: "23", name: "高山族"},
        {value: "24", name: "拉祜族"},
        {value: "25", name: "水族"},
        {value: "26", name: "东乡族"},
        {value: "27", name: "纳西族"},
        {value: "28", name: "景颇族"},
        {value: "29", name: "柯尔克孜族"},
        {value: "30", name: "土族"},
        {value: "31", name: "达翰尔族"},
        {value: "32", name: "仫佬族"},
        {value: "33", name: "布朗族"},
        {value: "34", name: "撒拉族"},
        {value: "35", name: "毛南族"},
        {value: "36", name: "仡佬族"},
        {value: "37", name: "锡伯族"},
        {value: "38", name: "阿昌族"},
        {value: "39", name: "普米族"},
        {value: "40", name: "塔吉克族"},
        {value: "41", name: "怒族"},
        {value: "42", name: "怒族"},
        {value: "43", name: "乌兹别克族"},
        {value: "44", name: "俄罗斯族"},
        {value: "45", name: "鄂温克族"},
        {value: "46", name: "德昂族"},
        {value: "47", name: "保安族"},
        {value: "48", name: "裕固族"},
        {value: "49", name: "京族"},
        {value: "50", name: "塔塔尔族"},
        {value: "51", name: "独龙族"},
        {value: "52", name: "鄂伦春族"},
        {value: "53", name: "赫哲族"},
        {value: "54", name: "珞巴族"},
        {value: "55", name: "基诺族"},
        {value: "56", name: "其它"}
      ],
      politicsMap: [
        {value: "1", name: "群众"},
        {value: "2", name: "中国共产党党员"},
        {value: "3", name: "中国农民民主党党员"},
        {value: "4", name: "中国致公党党员"},
        {value: "5", name: "中国共产党预备党员"},
        {value: "6", name: "九三学社社员"},
        {value: "7", name: "中国台湾同盟盟员"},
        {value: "8", name: "无党派民主人士"},
        {value: "9", name: "中国共产主义共青团团员"},
        {value: "10", name: "中国国民党革命委员会党员"},
        {value: "11", name: "中国民主同盟盟员"},
        {value: "12", name: "中国民主建国会委员"},
        {value:"13", name:"中国民主促进会会员"}
      ],
      error: {
        name: '',
        organization: '',
        position: '',
        phone: '',
        password: '',
        birthday: '',
        idNum: '',
        password2: ''
      },
      rules: {
        name: [
          {required: true, message: '姓名不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '姓名位2-20个字符', trigger: 'blur'},
        ],
        idNum: [
          {required: true, message: '身份证号不能为空', trigger: 'blur'},
          {min: 17, max: 20, message: '身份证号17-20个字符', trigger: 'blur'},
        ],
        organization: [
          {required: true, message: '工作单位不能为空', trigger: 'blur'},
          {min: 2, max: 20, message: '工作单位2-20个字符', trigger: 'blur'},
        ],
        position: [
          {required: true, message: '单位职务不能为空', trigger: 'blur'},
        ],
        phone: [
          {required: true, message: '手机号不能为空', trigger: 'blur'},
          {min: 11, max: 11, message: '手机号错误', trigger: 'blur'}
        ],
        birthday: [{required: true, message: '请选择一个日期', trigger: 'blur'}],
        politics: [{required: true, message: '政治面貌必须填写', trigger: 'blur'}],
        nation: [{required: true, message: '民族必须填写', trigger: 'blur'}],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        password: [{validator: validatePass, trigger: 'change'}],
        password2: [{validator: validatePass2, trigger: 'change'}],

      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          var that = this;
          var params = toUnderLineObj(this.form)

          createUserPerson(params)
            .then((response) => {
              // ✅ 注册成功，跳转到登录页
              message.success('注册成功，请等待管理员审核');
              that.$router.push({name: 'login'});
            })
            .catch(function(error) {
              console.log('===== 完整错误对象 =====');
              console.log('error:', error);
              console.log('========================');

              // ✅ 直接处理 error，因为它就是后端返回的数据
              if (error && typeof error === 'object') {
                let hasError = false;

                for (var key in error) {
                  if (Array.isArray(error[key]) && error[key].length > 0) {
                    var msg = error[key][0];
                    console.log('字段:', key, '错误信息:', msg);

                    // 映射到对应的 error 字段
                    switch(key) {
                      case 'phone':
                        that.error.phone = msg;
                        hasError = true;
                        break;
                      case 'linkphone':
                        that.error.linkphone = msg;
                        hasError = true;
                        break;
                      case 'name':
                        that.error.name = msg;
                        hasError = true;
                        break;
                      case 'password':
                        that.error.password = msg;
                        hasError = true;
                        break;
                      case 'password2':
                        that.error.password2 = msg;
                        hasError = true;
                        break;
                      case 'birthday':
                        that.error.birthday = msg;
                        hasError = true;
                        break;
                      case 'organization':
                        that.error.organization = msg;
                        hasError = true;
                        break;
                      case 'position':
                        that.error.position = msg;
                        hasError = true;
                        break;
                      case 'id_num':
                        that.error.idNum = msg;
                        hasError = true;
                        break;
                      case 'nation':
                        that.error.nation = msg;
                        hasError = true;
                        break;
                      case 'politics':
                        that.error.politics = msg;
                        hasError = true;
                        break;
                      case 'non_field_errors':
                        message.error(msg);
                        hasError = true;
                        break;
                      default:
                        // 显示其他错误
                        message.error(key + ': ' + msg);
                        hasError = true;
                    }
                  } else if (typeof error[key] === 'string') {
                    // 如果是字符串错误
                    message.error(error[key]);
                    hasError = true;
                  }
                }

                if (!hasError) {
                  message.error('操作失败，请稍后重试');
                }
              } else if (typeof error === 'string') {
                // 如果是字符串错误
                message.error(error);
              } else {
                message.error('操作失败，请检查网络连接');
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleNationChange(value) {

    },
    handleNationBlur() {

    },
    handleNationFocus() {

    },
    filterNationOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );

    },
    handlePoliticsChange(value) {

    },
    handlePoliticsBlur() {

    },
    handlePoliticsFocus() {

    },
    filterPoliticsOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );

    },
  }
}
</script>
<style scoped>
a:hover {
  color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/sign/Register.vue